import PageHeader from "@/components/shared/PageHeader";

export default function Terms() {
  return (
    <>
      <PageHeader overline="Legal" title="Terms of use." />
      <section className="ccdr-section">
        <div className="ccdr-narrow ccdr-prose">
          <p className="ccdr-lead">
            By using the Centre for Climate and Disaster Resilience website, you agree to the following terms.
          </p>
          <h2 className="ccdr-h3 mt-12 mb-4">Content</h2>
          <p>
            Content on this site is provided for informational purposes. It reflects the position of recognised global
            frameworks and standards as at mid-2026 and is reviewed periodically. The Centre references external bodies
            as authoritative sources; presence on this site does not imply endorsement.
          </p>
          <h2 className="ccdr-h3 mt-10 mb-4">No professional advice</h2>
          <p>
            Material on this site is not legal, financial, or technical advice. Decisions affecting people, assets, or
            policy should be taken with appropriate professional counsel.
          </p>
          <h2 className="ccdr-h3 mt-10 mb-4">Intellectual property</h2>
          <p>
            Unless otherwise stated, content authored by the Centre is available under terms to be set out separately.
            Third-party material is the property of the respective bodies.
          </p>
          <h2 className="ccdr-h3 mt-10 mb-4">Liability</h2>
          <p>
            The Centre makes reasonable efforts to ensure accuracy, but assumes no liability for losses arising from
            reliance on the site. External links are provided for convenience.
          </p>
          <p className="text-sm text-[#9CA3AF] mt-12">
            Last reviewed June 2026 · Entity: Centre for Climate and Disaster Resilience · Governing law: Australia. The site is intended for use worldwide.
          </p>
        </div>
      </section>
    </>
  );
}
